import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openFreezeRenewalModal = () => openPopupHelper({ popupName: popupNames.FREEZE_RENEWAL });
